import { Model } from './model';

export class AnnuncioAllegato extends Model {
  static apiUrl = 'annunci/allegati';

  nome_originale: string;
  tipo?: 'file' | 'video';
  mime?: string;
  dimensione?: number;
  download_url: string;
  stream_url?: string;

  deserialize(input: any): AnnuncioAllegato {
    let retV: AnnuncioAllegato = new AnnuncioAllegato();
    retV = super.deserialize(input) as AnnuncioAllegato;
    return retV;
  }

  get isVideo(): boolean {
    return this.tipo === 'video' || !!this.mime?.startsWith('video/');
  }

  getHumanIdentifier() {
    return this.nome_originale;
  }
}
